import { render } from "./Resep.vue?vue&type=template&id=aa0b59f0&scoped=true"
import script from "./Resep.vue?vue&type=script&lang=js"
export * from "./Resep.vue?vue&type=script&lang=js"

import "./Resep.vue?vue&type=style&index=0&id=aa0b59f0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Дентакорплюс\\dentakor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa0b59f0"]])

export default __exports__